interface SendbirdDefaultAdminMessage {
  message: string;
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'message' implicitly has an 'any' type.
export function SendbirdDefaultAdminMessage({ message }) {
  return (
    <div className="sendbird-admin-message">
      <span className="sendbird-admin-message__text sendbird-label sendbird-label--caption-2 sendbird-label--color-onbackground-2">
        {message}
      </span>
    </div>
  );
}
